import { Baseurl } from "./url";

export function getToken() {
    const tokenString = sessionStorage.getItem('token');

    const userToken = JSON.parse(tokenString);
    return userToken
    // Force logged in status
    //return 'lghkghkehgrekjhgk'
}
export function setToken(userToken) {
    sessionStorage.setItem('token', JSON.stringify(userToken.token));
    // "user" or "admin"; only used to decide what to show, the backend enforces it
    sessionStorage.setItem('role', userToken.role || 'user');
    //TODO: Set UID
}
export function clearToken() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('role');
}
// Asks the backend for the current role, in case it changed since login (e.g. promoted to
// admin). Returns the role, or null if it couldn't be checked.
export async function refreshRole() {
    try {
        const response = await fetch(`${Baseurl}/check-token`, { headers: { 'Authorization': getToken() } });
        const result = await response.json();
        if (result && result.valid && result.role) {
            sessionStorage.setItem('role', result.role);
            return result.role;
        }
    } catch (e) { /* offline etc: keep the role we have */ }
    return null;
}
export function getUserRole() {
    return sessionStorage.getItem('role') || 'user';
}
export function isAdmin() {
    return isUserLoggedIn() === true && getUserRole() === 'admin';
}
// The email the token was issued for (the JWT's "user" claim), or ''.
export function getUserEmail() {
    const claims = parseJwt(sessionStorage.getItem('token'));
    return claims && claims.user ? claims.user : '';
}
export function isUserLoggedIn() {
    const tokenString = sessionStorage.getItem('token');
    const decodedJwt = parseJwt(tokenString);
    if (!decodedJwt) return false;
    if (decodedJwt.exp * 1000 < Date.now()) {
        return null;
    }

    const userToken = JSON.parse(tokenString);
    if (userToken) return true;
    return false;
}

export function getUserID() {
    const fakeUID = "48fefe18-17cc-11ee-be56-0242ac120002"
    return fakeUID;
}

const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
